import { jsx as _jsx } from "react/jsx-runtime";
import TutorPage from "./TutorPage";
export default function MultiplicationPage() {
    return _jsx(TutorPage, { initialTopic: "Multiplication", lockTopic: true });
}
